module.exports = __webpack_public_path__ + "static/media/terms_fr.99d36052.txt";